export default __webpack_public_path__ + "static/wotif-offer-c6d67e73a98cd280e063d108e38bf2a1.webp";